import Separator from "@/components/atomic/Separator";
import { ActionSectionProps } from "./types";

export const ActionSection: React.FC<ActionSectionProps> = ({
  countermeasureDescription,
  t,
}) => {
  return (
    <>
      <Separator className="my-2.5 w-full" />
      <div className="relative w-full">
        <div className="font-bold text-[#858585] text-sm leading-[1.8]">
          {t("analysis.problem.action")}
        </div>
        <div className="relative pl-7 mt-2">
          <div className="absolute w-[3px] h-full top-0 left-0 bg-[#868686] rounded-[2px]" />
          <p className="text-[#858585] leading-[1.8]">
            {countermeasureDescription}
          </p>
        </div>
      </div>
    </>
  );
};
